const language = {
  namespaced: true,

  state: {
    language: null
  },

  mutations: {
    SET_LANGUAGE(state, payload) {
      state.language = payload
    }
  }
}

export default language
